export const dateGridLocalTextOptions = {
  columnMenuUnsort: "По умолчанию",
  columnMenuSortAsc: "По возрастанию",
  columnMenuSortDesc: "По убыванию!",
  columnMenuFilter: "Фильтр",
  columnMenuHideColumn: "Скрыть столбец",
  columnMenuLabel: "Меню",
  columnMenuManageColumns: "Настроить столбцы",
  columnsPanelTextFieldPlaceholder: "Название столбца",
  columnsPanelTextFieldLabel: "Поиск столбца",
  columnsPanelShowAllButton: "Показать все",
  columnsPanelHideAllButton: "Скрыть все",
  checkboxSelectionHeaderName: "Выбор строк",
  columnHeaderSortIconLabel: "Сортировка",
  filterOperatorContains: "содержит",
  filterOperatorEquals: "не содержит",
  filterOperatorStartsWith: "Начинается с",
  filterOperatorEndsWith: "кончается с",
  filterOperatorIs: "равен",
  filterOperatorNot: "не равен",
  filterOperatorAfter: "после",
  filterOperatorOnOrAfter: "в или после",
  filterOperatorBefore: "до",
  filterOperatorOnOrBefore: "до или в",
  filterOperatorIsEmpty: "пустой",
  filterOperatorIsNotEmpty: "не пустой",
  filterOperatorIsAnyOf: "что-нибудь из",
  "filterOperator=": "Равно",
  "filterOperator!=": "не равно",
  "filterOperator>": "больше",
  "filterOperator>=": "больше либо",
  "filterOperator<": "меньше",
  "filterOperator<=": "меньше либо равно",
};
